import { render, staticRenderFns } from "./CommuneView.vue?vue&type=template&id=6be22a88&scoped=true"
import script from "./CommuneView.vue?vue&type=script&lang=js"
export * from "./CommuneView.vue?vue&type=script&lang=js"
import style0 from "./CommuneView.vue?vue&type=style&index=0&id=6be22a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be22a88",
  null
  
)

export default component.exports